import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import underConstructionText from '../../constants/under-construction-text.json';

@Component({
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.sass'],
  standalone: true,
  imports: [RouterModule, CommonModule]
})
export class UnderConstructionComponent {
  txt = underConstructionText;

  data = signal<{ moduleName?: string } | null>(null);

  constructor(private readonly router: Router) {
    const navigation = this.router.getCurrentNavigation();

    if (navigation?.extras.state) {
      this.data.set(navigation.extras.state['data'] ?? null);
    }
  }
}
